var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcResManuals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21V5.5",
    stroke: "#909090",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5H9",
    stroke: "#909090",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8H8",
    stroke: "#909090",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.3631V3.5C2.5 2.94772 2.94731 2.50468 3.49805 2.546C4.64377 2.63195 6.58663 2.8785 8.30556 3.58571C9.37567 4.02599 10.8661 4.69772 11.5827 5.02366C11.8484 5.14453 12.1516 5.14453 12.4173 5.02366C13.1339 4.69772 14.6243 4.02599 15.6944 3.58571C17.4134 2.8785 19.3562 2.63195 20.502 2.546C21.0527 2.50469 21.5 2.94771 21.5 3.5V17.3631C21.5 17.8661 21.1265 18.2915 20.6292 18.3671C19.4674 18.5436 17.4184 18.8943 16.2222 19.3286C14.9796 19.7797 13.3561 20.6954 12.5311 21.181C12.2038 21.3737 11.7962 21.3737 11.4689 21.181C10.6439 20.6954 9.02041 19.7797 7.77778 19.3286C6.58155 18.8943 4.53256 18.5436 3.37083 18.3671C2.8735 18.2915 2.5 17.8661 2.5 17.3631Z",
    stroke: "#909090",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResManuals);
export default __webpack_public_path__ + "static/media/ic_res_manuals.efc0a2e58589c813c0ec019509e57083.svg";
export { ForwardRef as ReactComponent };